import React from 'react';
interface WineProduct {
  name: string;
  image: string;
}
const wines: WineProduct[] = [{
  name: '2022 Ridge Block Shiraz',
  image: 'https://assets.modern-commerce.io/Glenlofty%20Project%20Files/SINGLE%20VINEYARD%20Ridge%20Shiraz.png'
}, {
  name: '2023 Estate Cabernet Sauvignon',
  image: 'https://assets.modern-commerce.io/Glenlofty%20Project%20Files/ESTATE%20Cabernet%20Sauvignon.png'
}, {
  name: '2024 GO Chardonnay',
  image: 'https://assets.modern-commerce.io/Glenlofty%20Project%20Files/GO%20Chardonnay.png'
}];
export function BestSellingSection() {
  return <section className="bg-cream py-[40px] md:py-[60px] lg:py-[70px] px-6" data-id="element-10">
      <div className="max-w-[1100px] mx-auto" data-id="element-11">
        {/* Section Heading */}
        <h2 className="text-center font-optima uppercase tracking-[0.2em] text-charcoal mb-8 md:mb-10 text-[40px] font-[500]" data-id="element-12">
          Our Ranges
        </h2>

        {/* Wine Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-10 md:mb-12" data-id="element-13">
          {wines.map(wine => <a key={wine.name} href="#" className="group flex flex-col items-center text-center" data-id="element-14">
              {/* Bottle Image */}
              <div className="w-[260px] h-[300px] md:w-[280px] md:h-[340px] lg:w-[300px] lg:h-[380px] mb-4 flex items-end justify-center" data-id="element-15">
                <img src={wine.image} alt={wine.name} className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:-translate-y-2" data-id="element-16" />
              </div>

              {/* Wine Name */}
              <h3 className="text-[13px] md:text-[14px] font-optima font-medium uppercase tracking-[0.12em] text-charcoal leading-[1.5] max-w-[260px]" data-id="element-17">
                {wine.name}
              </h3>
            </a>)}
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-18">
          <button className="border border-charcoal bg-charcoal text-white px-16 py-4 uppercase tracking-[0.2em] text-[13px] font-medium hover:bg-white hover:text-charcoal hover:-translate-y-[2px] hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] transition-all duration-300 ease-out" data-id="element-19">
            View All Wines
          </button>
        </div>
      </div>
    </section>;
}